/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type RioShareReportMutationVariables = Types.Exact<{
  recipients:
    | Array<Types.Scalars['String']['input']>
    | Types.Scalars['String']['input']
  reportId: Types.Scalars['ID']['input']
}>

export type RioShareReportMutation = {
  __typename?: 'Mutation'
  rioShareReport: { __typename?: 'RioShareReportResponse'; success: boolean }
}

export const RioShareReportDocument = gql`
    mutation rioShareReport($recipients: [String!]!, $reportId: ID!) {
  rioShareReport(input: {reportId: $reportId, recipients: $recipients}) {
    success
  }
}
    `
export type RioShareReportMutationFn = Apollo.MutationFunction<
  RioShareReportMutation,
  RioShareReportMutationVariables
>

/**
 * __useRioShareReportMutation__
 *
 * To run a mutation, you first call `useRioShareReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRioShareReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rioShareReportMutation, { data, loading, error }] = useRioShareReportMutation({
 *   variables: {
 *      recipients: // value for 'recipients'
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useRioShareReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RioShareReportMutation,
    RioShareReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RioShareReportMutation,
    RioShareReportMutationVariables
  >(RioShareReportDocument, options)
}
export type RioShareReportMutationHookResult = ReturnType<
  typeof useRioShareReportMutation
>
export type RioShareReportMutationResult =
  Apollo.MutationResult<RioShareReportMutation>
export type RioShareReportMutationOptions = Apollo.BaseMutationOptions<
  RioShareReportMutation,
  RioShareReportMutationVariables
>
